<p-fileUpload #uploader id="fileUpload" name="fileUpload" [auto]="true"
              chooseLabel="defaultFileName ? 'Choose a different File' : 'Choose File'"
              (onRemove)="onFileRemove()"
              styleClass="" [multiple]="false"
              [accept]="acceptedFileTypes" [disabled]="!isEditing"
              [maxFileSize]="maxFileSize" customUpload="true" (uploadHandler)="onFileAdd($event)">
  <ng-template pTemplate="content">
    <p class="content-message">Drop  Your Files Here</p>
  </ng-template>
  <ng-template let-file pTemplate='file'>
    <div> {{file.name | ellipsis : 10: false}}</div>
    <div>{{ file.size / 1000 }} KB</div>
  </ng-template>
</p-fileUpload>
